import React, { useEffect, useState } from 'react'
import Header from 'components/layout/Header'
import Sidebar from 'components/layout/Sidebar'
import { useDispatch } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import useAuth from 'utils/hooks/useAuth'
import {  getPermissionData, getRoleData } from 'store/data/dataSlice'


export default function AppLayout() {
    const { authenticated } = useAuth()
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()

    useEffect(() => {
        if (!authenticated) {
            navigate('/login')
        } 
        // else {
        //     if (location.pathname === '/') {
        //     } else if (checkPermission(location.pathname.split('/')[location.pathname.split('/').length - 1])) {
        //     } else if (
        //         checkPermission(
        //             location.pathname.split('/')[1],
        //             location.pathname.split('/')[location.pathname.split('/').length - 1]
        //         )
        //     ) {
        //     } else if (
        //         checkPermission(
        //             location.pathname.split('/')[2],
        //             location.pathname.split('/')[location.pathname.split('/').length - 1]
        //         )
        //     ) {
        //     } else if (location.pathname.includes('profile')) {
        //     } else {
        //         navigate('/')
        //     }
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    useEffect(() => {
        if (authenticated) {
            // dispatch(getCompanyData())
            // dispatch(getBranchData())
            dispatch(getRoleData())
            dispatch(getPermissionData())
            // dispatch(getAddonData())
            // fetchData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, authenticated])

    

    return (
        <div className="dark:bg-boxdark2 dark:text-bodydark">
            {/* A1 — Skip-to-content for keyboard / screen-reader users (SEBI a11y). */}
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-primary focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
                Skip to main content
            </a>
            <div className="flex h-screen overflow-hidden">
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <main id="main-content" tabIndex={-1}>
                        <div className="p-4 mx-auto max-w-screen-2xl md:p-5 2xl:p-8">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    )
}
